import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { GlobalConstants } from '../app.component';
import { APIService } from '../common/api.component';
import { Constants } from '../common/constants';
import { ErrorData } from '../common/ErrorData';
import { SharedService } from '../common/shared.service';
import { ShareUtils } from '../common/shareutils';
import { Utils } from '../common/utils.component';
import { Drmsetting } from '../models/drmsetting';
import { Option } from '../models/option';
import { Options } from '../models/options';
import { Quicksharelinkexpiry } from '../models/quicksharelinkexpiry';
import { ShareSettings } from '../models/sharesettin';
import { ShareViaLink } from '../models/sharevialink';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html'
})
export class SettingsComponent implements OnInit {

  HighQDemoText: string = Constants.HIGHQDEMOTEXT;
  HighQDemoLinkText: string = Constants.HIGHQDEMOLINKTEXT;
  HighQDemoTextEnd: string = Constants.HIGHQDEMOTEXTEND;
  HighQDemoLink: string = Constants.HIGHQDEMOLINK;
  LoginKBNoteText: string = Constants.LoginKBNoteText;
  LoginKBNoteLinkText: string = Constants.LoginKBNoteLinkText;
  KnowledgebaseLink: string = Constants.KNOWLEDGEBASELINK;
  loading: boolean = true;
  accessibleMyfiles: Option[];
  downloadrightsMyfiles: Option[];

  accessibleOtherfiles: Option[];
  downloadrightsOtherfiles: Option[];
  linkexpires: Option[];

  accessibleindexMyfiles: number;
  downloadindexMyfiles: number;

  accessibleindexOtherfiles: number;
  downloadindexOtherfiles: number;

  linkindex: number;

  accessibleByFg: FormGroup;
  accessibleByFgOther: FormGroup;
  downloadRightsFg: FormGroup;
  downloadRightsFgOther: FormGroup;
  linkExpiresFg: FormGroup;
  passwordFg: FormGroup;
  passwordFgOther: FormGroup;

  isWaterMark: boolean;
  isApproveVersions: boolean;
  isWaterMarkOther: boolean;
  isApproveVersionsOther: boolean;
  notifyEditdownload: boolean;
  showdialog: boolean;
  isValid = true;
  username: string;
  useremail: string;
  instancename: string;
  password: string;
  passwordOther: string;
  shareSettings: ShareSettings;
  errorMsg = ""
  hidemysite: boolean = true;
  hideothersite: boolean = true;

  passwordFc = new FormControl('', [Validators.maxLength(Constants.MAXPASSWORDCHAR), this.noWhitespaceValidator, Constants.passwordValidator]);
  passwordFcOther = new FormControl('', [Validators.maxLength(Constants.MAXPASSWORDCHAR), this.noWhitespaceValidator, Constants.passwordValidator]);

  public barLabel: string = Constants.PASSWORD_STRENGTH;

  constructor(
    private apiService: APIService,
    private sharedService: SharedService,
    private utils: Utils,
    private shareUtils: ShareUtils,
    private dialog: MatDialog) { }

  ngOnInit() {
    this.apiService.ValidateMsTeamContextAndFatchTeamsId(this.sharedService);
    this.apiService.setTheme();
    if (GlobalConstants.Tid.length > 0) {
      this.AuthenticateUser();
    }
  }

  public getPasswordIconMySite() {
    if (this.hidemysite)
      return "hide";
    else
      return "show"
  }

  public getPasswordIconOtherSite() {
    if (this.hideothersite)
      return "hide";
    else
      return "show"
  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    const lengthLess = (control.value || '').trim().length < 5;
    return isValid && !lengthLess ? null : { 'whitespace': true };
  }

  tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    this.clearErrorMsg()
    if (tabChangeEvent.index == 1)
      this.getAccountDetails();
    else if (tabChangeEvent.index == 0)
      this.getShareSettings();
  }

  clearErrorMsg() {
    this.errorMsg = ""
  }

  public AuthenticateUser() {
    this.apiService.authenticateUserCall()
      .subscribe(data => {
        if (data['Key'] == "Authenticate" && data['Value'].length > 0) {
          GlobalConstants.Jwi = data['Value'];

          this.sharedService.settingsScreen(true)

          this.accessibleByFg = new FormGroup({
            accessibleByFc: new FormControl()
          });

          this.accessibleByFgOther = new FormGroup({
            accessibleByFcOther: new FormControl()
          });

          this.downloadRightsFg = new FormGroup({
            downloadRightsFc: new FormControl()
          });

          this.downloadRightsFgOther = new FormGroup({
            downloadRightsFcOther: new FormControl()
          });

          this.linkExpiresFg = new FormGroup({
            linkExpiresFc: new FormControl()
          });
          this.getShareSettings();
        } else {
          this.sharedService.logout();

        }
      }, err => {
        this.utils.openConfirmationDialog({ errorData: err }, this.dialog, item => {
          this.apiService.logoutUser().subscribe(data => {
            this.sharedService.logout()
          }, errData => {
            this.errorMsg = errData.errorMsg
          })

        })
      });
  }

  ngAfterViewChecked() {
    if (!this.loading) {
      this.utils.setContentHeight(false, true, false, true, false);
    }
  }
  getAccountDetails() {
    this.loading = true;
    this.apiService.getAccountDetails()
      .subscribe(accountdetails => {
        this.username = accountdetails['username'];
        this.useremail = accountdetails['useremail'];
        this.instancename = accountdetails['instanceurl'];
        this.loading = false;
      }, err => {
        this.loading = false;
        this.errorMsg = err.errorMsg
      });

  }
  getErrorMessage(passwordFc) {
    return this.shareUtils.getErrorMessage(passwordFc);
  }

  setDataFromAPI(share: ShareSettings) {
    this.setAccessibleByDataFromAPI(share)
    this.setDownloadRightDataFromAPI(share)
    if (share.quicksharelinkexpiry.options.option.length == 1) {
      var indexlink = this.shareUtils.optionsSharelinkexpire.findIndex(item => item.alias === share.quicksharelinkexpiry.options.option[0].alias);
      this.shareUtils.optionsSharelinkexpire[indexlink].default = true;
      this.linkexpires = this.shareUtils.optionsSharelinkexpire;
    } else {
      this.linkexpires = share.quicksharelinkexpiry.options.option;
    }
  }

  setAccessibleByDataFromAPI(share: ShareSettings) {
    if (share.sharevialink.options.option.length == 1) {
      var index = this.shareUtils.optionsAccessibleMysite.findIndex(item => item.alias === share.sharevialink.options.option[0].alias);
      this.shareUtils.optionsAccessibleMysite[index].default = true;
      this.accessibleMyfiles = this.shareUtils.optionsAccessibleMysite;
      if (share.sitesharevialink == undefined || share.sitesharevialink.options.option[0].alias.length == 0) {
        this.accessibleOtherfiles = this.shareUtils.optionsAccessibleOthersite;
      } else {
        this.shareUtils.optionsAccessibleOthersite[index].default = false;
        var otherindex = this.shareUtils.optionsAccessibleOthersite.findIndex(item => item.alias === share.sitesharevialink.options.option[0].alias);

        this.shareUtils.optionsAccessibleOthersite[otherindex].default = true;
        this.accessibleOtherfiles = this.shareUtils.optionsAccessibleOthersite;
      }
    } else {
      this.accessibleMyfiles = share.sharevialink.options.option;
      if (share.sitesharevialink != null)
        this.accessibleOtherfiles = share.sitesharevialink.options.option;
      else
        this.accessibleOtherfiles = share.sharevialink.options.option;
    }
  }

  setDownloadRightDataFromAPI(share: ShareSettings) {
    if (share.drmsetting.options.option.length == 1) {
      var indexdrm = this.shareUtils.optionsDrmMysite.findIndex(item => item.alias === share.drmsetting.options.option[0].alias);
      this.shareUtils.optionsDrmMysite[indexdrm].default = true;
      this.downloadrightsMyfiles = this.shareUtils.optionsDrmMysite;
      if (share.sitedrmsetting == undefined || share.sitedrmsetting.options.option[0].alias.length == 0) {
        this.downloadrightsOtherfiles = this.shareUtils.optionsDrmOthersite;
      } else {
        this.shareUtils.optionsDrmOthersite[indexdrm].default = false;
        var otherindexdrm = this.shareUtils.optionsDrmOthersite.findIndex(item => item.alias === share.sitedrmsetting.options.option[0].alias);
        this.shareUtils.optionsDrmOthersite[otherindexdrm].default = true;
        this.downloadrightsOtherfiles = this.shareUtils.optionsDrmOthersite;
      }
    } else {
      this.downloadrightsMyfiles = share.drmsetting.options.option;
      if (share.sitedrmsetting != null)
        this.downloadrightsOtherfiles = share.sitedrmsetting.options.option;
      else
        this.downloadrightsOtherfiles = share.drmsetting.options.option;
    }
  }

  getShareSettings() {
    this.loading = true;
    var islocal = this.shareUtils.getIsLocal();
    this.apiService.getDRMSettings(islocal)
      .subscribe(share => {
        this.shareSettings = share;
        this.setDataFromAPI(share)

        this.setMyFileShareSettings(share)
        this.setOtherFileShareSettings(share)

        if (localStorage.getItem(Constants.WATERMARK_OTHERFILES_STORAGE) == '1')
          this.isWaterMarkOther = true
        else
          this.isWaterMarkOther = false

        if (localStorage.getItem(Constants.APPROVE_NEW_VERSIONS_OTHERFILES_STORAGE) == '1')
          this.isApproveVersionsOther = true
        else
          this.isApproveVersionsOther = false

        if (localStorage.getItem(Constants.LINKEXPIRES_STORAGE) == "undefined" || Number(localStorage.getItem(Constants.LINKEXPIRES_STORAGE)) < 0) {
          this.linkExpiresFg.get('linkExpiresFc').setValue(this.linkexpires.find(link => link.default))
          this.linkindex = this.linkexpires.findIndex(item => item.displayname === this.linkExpiresFg.get('linkExpiresFc').value.displayname);
        } else {
          this.linkExpiresFg.get('linkExpiresFc').setValue(this.linkexpires[Number(localStorage.getItem(Constants.LINKEXPIRES_STORAGE))]);
          this.linkindex = this.linkexpires.findIndex(item => item.displayname === this.linkExpiresFg.get('linkExpiresFc').value.displayname);
        }

        if (localStorage.getItem(Constants.NOTIFY_EDIT_DOWNLOAD_PRINT_STORAGE) == '1')
          this.notifyEditdownload = true
        else
          this.notifyEditdownload = false

        if (localStorage.getItem(Constants.SHOW_DIALOG_STORAGE) != null && localStorage.getItem(Constants.SHOW_DIALOG_STORAGE) != 'true')
          this.showdialog = false
        else {
          this.showdialog = true
          localStorage.setItem(Constants.SHOW_DIALOG_STORAGE, 'true');
        }

        this.loading = false;
      }, err => {
        this.loading = false;
        this.errorMsg = err.errorMsg
      });
  }

  setMyFileShareSettings(share: ShareSettings) {
    //Set Accessible(Share link) settings for My site
    if (Number(localStorage.getItem(Constants.ACCESSIBLEBY_MYFILES_STORAGE)) > 0 && !share.sharevialinkrestrict) {
      this.accessibleByFg.get('accessibleByFc').setValue(this.accessibleMyfiles[Number(localStorage.getItem(Constants.ACCESSIBLEBY_MYFILES_STORAGE)) - 1]);
      this.accessibleindexMyfiles = this.accessibleMyfiles.findIndex(item => item.displayname === this.accessibleByFg.get('accessibleByFc').value.displayname);

    } else {
      this.accessibleByFg.get('accessibleByFc').setValue(this.accessibleMyfiles.find(access => access.default))
      this.accessibleindexMyfiles = this.accessibleMyfiles.findIndex(item => item.displayname === this.accessibleByFg.get('accessibleByFc').value.displayname);
      if (share.sharevialinkrestrict)
        this.accessibleByFg.get('accessibleByFc').disable();
    }

    //Set DRM settings for My site
    if (Number(localStorage.getItem(Constants.DOWNLOADRIGHTS_MYFILES_STORAGE)) > 0 && !share.drmsettingrestrict) {
      this.downloadRightsFg.get('downloadRightsFc').setValue(this.downloadrightsMyfiles[Number(localStorage.getItem(Constants.DOWNLOADRIGHTS_MYFILES_STORAGE)) - 1]);
      this.downloadindexMyfiles = this.downloadrightsMyfiles.findIndex(item => item.displayname === this.downloadRightsFg.get('downloadRightsFc').value.displayname);
    } else {
      this.downloadRightsFg.get('downloadRightsFc').setValue(this.downloadrightsMyfiles.find(download => download.default))
      this.downloadindexMyfiles = this.downloadrightsMyfiles.findIndex(item => item.displayname === this.downloadRightsFg.get('downloadRightsFc').value.displayname);
      if (share.drmsettingrestrict)
        this.downloadRightsFg.get('downloadRightsFc').disable();
    }

    if (localStorage.getItem(Constants.WATERMARK_MYFILES_STORAGE) == '1')
      this.isWaterMark = true
    else
      this.isWaterMark = false

    if (localStorage.getItem(Constants.APPROVE_NEW_VERSIONS_MYFILES_STORAGE) == '1')
      this.isApproveVersions = true
    else
      this.isApproveVersions = false

    if (share.pwrd)
      this.password = share.pwrd;
  }

  setOtherFileShareSettings(share: ShareSettings) {
    //Set Accessible(Share link) settings for other site
    if (Number(localStorage.getItem(Constants.ACCESSIBLEBY_OTHERFILES_STORAGE)) > 0 && !share.sitesharevialinkrestrict) {
      this.accessibleByFgOther.get('accessibleByFcOther').setValue(this.accessibleOtherfiles[Number(localStorage.getItem(Constants.ACCESSIBLEBY_OTHERFILES_STORAGE)) - 1]);
      this.accessibleindexOtherfiles = this.accessibleOtherfiles.findIndex(item => item.displayname === this.accessibleByFgOther.get('accessibleByFcOther').value.displayname);
    } else {
      this.accessibleByFgOther.get('accessibleByFcOther').setValue(this.accessibleOtherfiles.find(access => access.default))
      this.accessibleindexOtherfiles = this.accessibleOtherfiles.findIndex(item => item.displayname === this.accessibleByFgOther.get('accessibleByFcOther').value.displayname);
      if (share.sitesharevialinkrestrict)
        this.accessibleByFgOther.get('accessibleByFcOther').disable();
    }

    //Set DRM settings for Other site
    if (Number(localStorage.getItem(Constants.DOWNLOADRIGHTS_OTHERFILES_STORAGE)) > 0 && !share.sitedrmsettingrestrict) {
      this.downloadRightsFgOther.get('downloadRightsFcOther').setValue(this.downloadrightsOtherfiles[Number(localStorage.getItem(Constants.DOWNLOADRIGHTS_OTHERFILES_STORAGE)) - 1]);
      this.downloadindexOtherfiles = this.downloadrightsOtherfiles.findIndex(item => item.displayname === this.downloadRightsFgOther.get('downloadRightsFcOther').value.displayname);
    } else {
      this.downloadRightsFgOther.get('downloadRightsFcOther').setValue(this.downloadrightsOtherfiles.find(download => download.default))
      this.downloadindexOtherfiles = this.downloadrightsOtherfiles.findIndex(item => item.displayname === this.downloadRightsFgOther.get('downloadRightsFcOther').value.displayname);
      if (share.sitedrmsettingrestrict)
        this.downloadRightsFgOther.get('downloadRightsFcOther').disable();
    }
    if (share.sitepwrd)
      this.passwordOther = share.sitepwrd;
  }

  save() {
    this.clearErrorMsg()
    this.loading = true;
    this.accessibleindexMyfiles = this.accessibleMyfiles.findIndex(item => item.displayname === this.accessibleByFg.value.accessibleByFc.displayname);
    this.downloadindexMyfiles = this.downloadrightsMyfiles.findIndex(item => item.displayname === this.downloadRightsFg.value.downloadRightsFc.displayname);

    this.accessibleindexOtherfiles = this.accessibleOtherfiles.findIndex(item => item.displayname === this.accessibleByFgOther.value.accessibleByFcOther.displayname);
    this.downloadindexOtherfiles = this.downloadrightsOtherfiles.findIndex(item => item.displayname === this.downloadRightsFgOther.value.downloadRightsFcOther.displayname);

    this.linkindex = this.linkexpires.findIndex(item => item.displayname === this.linkExpiresFg.value.linkExpiresFc.displayname);

    const saveSharesettings = new ShareSettings();

    saveSharesettings.shareviaemailrestrict = this.shareSettings.shareviaemailrestrict;
    saveSharesettings.shareviaemail = new ShareViaLink()
    saveSharesettings.shareviaemail.options = new Options()
    saveSharesettings.shareviaemail.options.option = [this.accessibleMyfiles[this.accessibleindexMyfiles]];

    saveSharesettings.sharevialinkrestrict = this.shareSettings.sharevialinkrestrict;
    saveSharesettings.sharevialink = new ShareViaLink()
    saveSharesettings.sharevialink.options = new Options()
    saveSharesettings.sharevialink.options.option = [this.accessibleMyfiles[this.accessibleindexMyfiles]];

    saveSharesettings.drmsetting = new Drmsetting()
    saveSharesettings.drmsetting.options = new Options()
    saveSharesettings.drmsettingrestrict = this.shareSettings.drmsettingrestrict;
    saveSharesettings.drmsetting.options.option = [this.downloadrightsMyfiles[this.downloadindexMyfiles]];
    if (this.password != null)
      saveSharesettings.pwrd = this.utils.getEncryptedHeaderString(this.password.trim());
    saveSharesettings.approvenewversions = this.isApproveVersions;
    saveSharesettings.applywatermark = this.isWaterMark;

    saveSharesettings.siteshareviaemailrestrict = this.shareSettings.siteshareviaemailrestrict;
    saveSharesettings.siteshareviaemail = new ShareViaLink()
    saveSharesettings.siteshareviaemail.options = new Options()
    saveSharesettings.siteshareviaemail.options.option = [this.accessibleOtherfiles[this.accessibleindexOtherfiles]];

    saveSharesettings.sitesharevialinkrestrict = this.shareSettings.sharevialinkrestrict;
    saveSharesettings.sitesharevialink = new ShareViaLink()
    saveSharesettings.sitesharevialink.options = new Options()
    saveSharesettings.sitesharevialink.options.option = [this.accessibleOtherfiles[this.accessibleindexOtherfiles]];

    saveSharesettings.sitedrmsettingrestrict = this.shareSettings.drmsettingrestrict;
    saveSharesettings.sitedrmsetting = new Drmsetting()
    saveSharesettings.sitedrmsetting.options = new Options()
    saveSharesettings.sitedrmsetting.options.option = [this.downloadrightsOtherfiles[this.downloadindexOtherfiles]];
    if (this.passwordOther != null)
      saveSharesettings.sitepwrd = this.utils.getEncryptedHeaderString(this.passwordOther.trim());
    saveSharesettings.siteapprovenewversions = this.isApproveVersionsOther;
    saveSharesettings.siteapplywatermark = this.isWaterMarkOther;

    saveSharesettings.quicksharelinkexpiry = new Quicksharelinkexpiry()
    saveSharesettings.quicksharelinkexpiry.options = new Options()
    saveSharesettings.quicksharelinkexpiry.options.option = [this.linkexpires[this.linkindex]];


    saveSharesettings.sitequicksharelinkexpiry = new Quicksharelinkexpiry()
    saveSharesettings.sitequicksharelinkexpiry.options = new Options()
    saveSharesettings.sitequicksharelinkexpiry.options.option = [this.linkexpires[this.linkindex]];

    saveSharesettings.notification = this.notifyEditdownload;
    saveSharesettings.displaysharesettings = this.showdialog;

    this.apiService.saveShareSettings(saveSharesettings)
      .subscribe(share => {
        localStorage.setItem(Constants.ACCESSIBLEBY_MYFILES_STORAGE, (this.accessibleindexMyfiles + 1) + "");

        localStorage.setItem(Constants.DOWNLOADRIGHTS_MYFILES_STORAGE, (this.downloadindexMyfiles + 1) + "");

        localStorage.setItem(Constants.ACCESSIBLEBY_OTHERFILES_STORAGE, (this.accessibleindexOtherfiles + 1) + "");

        localStorage.setItem(Constants.DOWNLOADRIGHTS_OTHERFILES_STORAGE, (this.downloadindexOtherfiles + 1) + "");

        localStorage.setItem(Constants.LINKEXPIRES_STORAGE, this.linkindex + "");

        localStorage.setItem(Constants.WATERMARK_MYFILES_STORAGE, (this.isWaterMark ? 1 : 0) + "");
        localStorage.setItem(Constants.WATERMARK_OTHERFILES_STORAGE, (this.isWaterMarkOther ? 1 : 0) + "");

        localStorage.setItem(Constants.APPROVE_NEW_VERSIONS_MYFILES_STORAGE, (this.isApproveVersions ? 1 : 0) + "");
        localStorage.setItem(Constants.APPROVE_NEW_VERSIONS_OTHERFILES_STORAGE, (this.isApproveVersionsOther ? 1 : 0) + "");

        localStorage.setItem(Constants.NOTIFY_EDIT_DOWNLOAD_PRINT_STORAGE, (this.notifyEditdownload ? 1 : 0) + "");

        localStorage.setItem(Constants.SHOW_DIALOG_STORAGE, (this.showdialog) + "");

        //   localStorage.setItem(Constants.PASSWORD_MYFILES_STORAGE, this.password);
        //   localStorage.setItem(Constants.PASSWORD_OTHERFILES_STORAGE, this.passwordOther);

        this.loading = false;
      }, err => {
        this.loading = false;
        this.errorMsg = err.errorMsg
      });


  }
  onAccessibleChange(newValue) {
    this.clearErrorMsg()
    this.accessibleindexMyfiles = this.accessibleMyfiles.findIndex(item => item.displayname === newValue.value.displayname);
    // if (this.accessibleindexMyfiles == 3)
    //   this.showdialog = true;

  }
  onDownloadChange(newValue) {
    this.clearErrorMsg()
    this.downloadindexMyfiles = this.downloadrightsMyfiles.findIndex(item => item.displayname === newValue.value.displayname);
  }

  onLinkChange(newValue) {
    this.clearErrorMsg()
    this.linkindex = this.linkexpires.findIndex(item => item.displayname === newValue.value.displayname);
  }

  onAccessibleChangeOther(newValue) {
    this.clearErrorMsg()
    this.accessibleindexOtherfiles = this.accessibleOtherfiles.findIndex(item => item.displayname === newValue.value.displayname);
    // if (this.accessibleindexOtherfiles == 3)
    //   this.showdialog = true;

  }
  onDownloadChangeOther(newValue) {
    this.clearErrorMsg()
    this.downloadindexOtherfiles = this.downloadrightsOtherfiles.findIndex(item => item.displayname === newValue.value.displayname);
  }

  onToggleWaterMark(value) {
    this.clearErrorMsg()
    this.isWaterMark = value;
  }

  onToggleWaterMarkOther(value) {
    this.clearErrorMsg()
    this.isWaterMarkOther = value;
  }

  onToggleApproveVersion(value) {
    this.clearErrorMsg()
    this.isApproveVersions = value;
  }

  onToggleApproveVersionOther(value) {
    this.clearErrorMsg()
    this.isApproveVersionsOther = value;
  }

  onToggleNotify(value) {
    this.clearErrorMsg()
    this.notifyEditdownload = value;

  }
  onToggleShowDialog(value) {
    this.clearErrorMsg()
    this.showdialog = value;
  }

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.sharedService.settingsScreen(false)
  }

  logout() {
    var errorData = new ErrorData()
    errorData.errorMsg = Constants.SURE_LOGOUT;
    errorData.errorCode = Constants.SURE_LOGOUT_CODE;

    this.utils.openConfirmationDialog({ errorData: errorData }, this.dialog, item => {
      if (item) {
        this.apiService.logoutUser()
          .subscribe(share => {
            localStorage.clear();
            this.sharedService.logout();
          }, err => {
            this.errorMsg = err.errorMsg
          });
      }
    })
  }

  closeDialog() {
    this.shareUtils.closeMainDialog(this.apiService);
  }
}
